if (!customElements.get("op-service-bar")){
customElements.define("op-service-bar", class extends HTMLElement{
    connectedCallback(){
        this.sectionid = this.getAttribute("data-section-id");
        this.elementsQuantity = Number(this.dataset.elementsQuantity);

        // Check if there's enough elements to use the slider
        this.slidesPerViewMobile = this.elementsQuantity >= 2 ? 2 : 1;
        this.slidesPerViewDesktop = this.elementsQuantity >= 4 ? 4 : this.elementsQuantity;
        
        if (typeof Swiper === 'undefined') {
            console.error('Swiper non è stato caricato correttamente');
            return;
          }
          this.swiper = new Swiper(".swiper-" + this.sectionid, {
            slidesPerView: "auto",
            direction: "horizontal",
            loop: false,
            freeMode: true,
            breakpoints: {
              1024: {
                spaceBetween: 20,
              }
            }
          });
    }

    disconnectedCallback(){
        this.swiper?.destroy();
    }
})

}